<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<p class="first first-in-chapter first-full-width copyright-content">This book is a work of nonfiction. These accounts are from the author’s perspective and memories, and as such, are represented as accurately and faithfully as possible. To maintain the anonymity of the individuals involved, some of the names and details have been changed.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">CHOICES: Book 6: Standing in the Gap or in God’s Way?</p>
<p class="subsq copyright-content">Copyright © 2021 by Pat G’Orge-Walker</p>
<p class="subsq copyright-content">Edited by J.L. Campbell:  <a class="content-external-link text-is-url" href="mailto:JLCampbellwrites@gmail.com">JLCampbellwrites@gmail.com</a> and Lissa Woodson: <a class="content-external-link text-is-url" href="http://www.naleighnakai.com" target="_blank">www.naleighnakai.com</a></p>
<p class="subsq copyright-content">Cover Designed by J.L. Woodson: <a class="content-external-link text-is-url" href="http://www.woodsoncreativestudio.com" target="_blank">www.woodsoncreativestudio.com</a></p>
<p class="subsq copyright-content">Interior Designed by Lissa Woodson: <a class="content-external-link text-is-url" href="http://www.naleighnakai.com" target="_blank">www.naleighnakai.com</a></p>
<p class="subsq copyright-content">ISBN (trade paperback) 978-0-9660155-4-6</p>
<p class="subsq copyright-content">ISBN (eBook) 978-0-9660155-2-2</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">Without limiting the rights under copyright reserved above, no part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the express written permission of both the copyright owner and the publisher of this book, except in the case of brief quotations embodied in critical articles and reviews.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">For permission, contact Pat G’Orge-Walker at <a class="content-external-link text-is-url" href="mailto:Patgauthor@aol.com">Patgauthor@aol.com</a></p>
<p class="subsq copyright-content">234 Chestnut Lane</p>
<p class="subsq copyright-content">Statesville, NC 28625</p>
<p class="subsq copyright-content">www.pgorgewalker.com</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">The scanning, uploading, and distribution of this book via the Internet or via any other means without the permission of the owner is illegal and punishable by law. Please purchase only authorized electronic editions do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">If you purchase this book without a cover, you should be aware that this book is stolen property. It is reported as “unsold and destroyed” to the publisher, and neither the author nor the publisher has received any payment for this “stripped” book.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">All Scripture quotations are taken from the King James Version ®. Copyright © 1982 by Thomas Nelson. Used by permission. All Rights reserved.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6d0c9364